import {Component, Input} from '@angular/core';
import {CoreMenu} from '../../../../types';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[core-menu-horizontal-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuHorizontalItemComponent {
  @Input()
  item: CoreMenu;
}
